import {CreditRepositoryImpl} from '../repository/CreditRepositoryImpl';
import {UpdateStoreCreditLimitUseCase} from '../useCases/UpdateStoreCreditLimitUseCase';

// Singleton pattern for credit instances
class CreditFactory {
  private static instance: CreditFactory;
  private repository: CreditRepositoryImpl;
  private useCases: {
    updateCreditLimit: UpdateStoreCreditLimitUseCase;
  };

  private constructor () {
    this.repository = new CreditRepositoryImpl();
    this.useCases = {
      updateCreditLimit: new UpdateStoreCreditLimitUseCase(this.repository)
    };
  }

  public static getInstance (): CreditFactory {
    if (!CreditFactory.instance) {
      CreditFactory.instance = new CreditFactory();
    }
    return CreditFactory.instance;
  }

  public getRepository (): CreditRepositoryImpl {
    return this.repository;
  }

  public getUseCases () {
    return this.useCases;
  }
}

export const creditFactory = CreditFactory.getInstance();
